<template>
  <collapsed-section :title="'Pet ' + (index + 1)" :open="true">
    <labeled-form-control label="Pet Name">
      <input
        v-model="name"
        class="form-control"
        type="text"
        placeholder="Enter Pet Name"
        @focus="handleFocus('name')"
        @blur="handleBlur"
      />
      <validation-message v-if="validator.name" :message="validator.name"/>
    </labeled-form-control>

    <pet-breed :pet-id="petId" :validator="validator.breedId"/>
    <pet-dob :pet-id="petId"/>
    <pet-gender :pet-id="petId"/>
    <pet-neutered :pet-id="petId"/>
    <medical-note :pet-id="petId"/>

    <button v-if="index !== 0" class="btn btn-danger text-white ml-auto" @click="deletePet">
      <i class="fas fa-trash-alt"></i>
      Delete Pet {{ index + 1 }}
    </button>
  </collapsed-section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { PetHelper } from '@/helpers/PetHelper'
import CollapsedSection from '@/components/Layout/CollapsedSection.vue'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import PetBreed from './PetBreed.vue'
import PetDob from './PetDob.vue'
import PetGender from './PetGender.vue'
import PetNeutered from './PetNeutered.vue'
import PetMedicalNote from './PetMedicalNote.vue'

export default {
  name: 'PetDetails',
  props: {
    index: Number,
    petId: String
  },
  data () {
    return {
      validator: PetHelper.getPetValidator(),
      requiredFocused: {
        name: false
      }
    }
  },
  computed: {
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    ...mapGetters('ClientRegistrationUpload', [
      'findPet'
    ]),
    pet () {
      return this.findPet(this.petId)
    },
    name: {
      get () {
        return this.pet.name
      },
      set (value) {
        this.updatePetName({ petId: this.petId, value })
      }
    },
    allRequiredFocused () {
      return this.requiredFocused.name
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validate()
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updatePetName',
      'updatePetIsValid'
    ]),
    handleFocus (field) {
      if (field in this.requiredFocused) {
        this.requiredFocused[field] = true
      }
    },
    handleBlur () {
      if (this.allRequiredFocused) {
        this.validate()
      }
    },
    deletePet () {
      if (this.index !== 0) {
        this.$emit('deletePet', this.petId)
      }
    },
    validate () {
      this.validator.check(this.pet)
      this.updatePetIsValid({ petId: this.petId, value: this.validator.isValid })
    }
  },
  components: {
    'pet-breed': PetBreed,
    'pet-dob': PetDob,
    'pet-gender': PetGender,
    'pet-neutered': PetNeutered,
    'medical-note': PetMedicalNote,
    'labeled-form-control': LabeledFormControl,
    'collapsed-section': CollapsedSection,
    'validation-message': ValidationMessage
  }
}
</script>
